/**
 * Types mirroring the kor_nft_api moderator-onboarding module response.
 * Keep in sync with kor_nft_api/src/moderator-onboarding/types/moderator-onboarding.types.ts
 */

export enum ModeratorTaskType {
  REVIEW_REPORTS = 'review_reports',
  SET_NOTIFICATIONS = 'set_notifications',
  REMOVE_CONTENT = 'remove_content',
}

export type ModeratorOnboardingAction = 'seen' | 'skip' | 'dismiss_forever' | 'complete_task';

export interface ModeratorTaskWithProgress {
  key: ModeratorTaskType;
  title: string;
  description: string;
  mediaURI: {
    type: 'image' | 'video';
    desktopURI: string;
    mobileURI: string;
  };
  /** Deep-link template resolved on the client. Placeholders: {{creatorId}}, {{communityId}}, {{communitySlug}}. */
  route: string | null;
  default_order: number;
  completed: boolean;
  completed_at: string | null;
}

export interface ModeratorOnboardingStateData {
  _id: string;
  user_id: string;
  community_id: string;
  seen_at: string | null;
  skipped_at: string | null;
  dismissed_forever: boolean;
  tasks: Record<string, { completed: boolean; completed_at: string | null }>;
  createdAt: string;
  updatedAt: string;
}

export interface ModeratorOnboardingResponse {
  /** Whether the intro carousel should be shown for this community right now. */
  shouldShowIntro: boolean;
  /** True if the user opted out of the intro across all communities. */
  dismissedForever: boolean;
  state: ModeratorOnboardingStateData;
  tasks: ModeratorTaskWithProgress[];
}
